import { useEvent } from '@bizzabo/entities';
import useEventUniqueName from './useEventUniqueName';

const useEventId = () => {
    const eventUniqueName = useEventUniqueName();
    const event = useEvent(eventUniqueName, {
        notifyOnChangeProps: ['data'],
    });

    return event.data?.id;
};

export default useEventId;
